/**
 * Phase 3 shell unification — `Footer` is now an alias for the unified
 * `<SiteFooter>` (see `./site-footer.tsx`). Every page that previously
 * imported the old app footer gets the unified shell automatically.
 *
 * New code should import `SiteFooter` directly; this shim exists so
 * the ~40 existing call sites don't all need touching in one sweep.
 *
 * @deprecated import { SiteFooter } from "@/components/layout/site-footer"
 */

export { SiteFooter as Footer } from "./site-footer";
